<template>
    <div class="ag-header-group-cell-label" ref="agContainer" role="presentation">
        <el-tooltip placement="bottom"
                    :open-delay="500"
                    :disabled="!params.tooltip"
        >
            <span slot="content" v-html="params.tooltip"></span>
            <span ref="agLabel" class="ag-header-group-text" role="columnheader"
                  v-html="params.displayName"
            ></span>
        </el-tooltip>
        <template v-if="params.columnGroup.isExpandable()">
            <span ref="agOpened" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded"  aria-hidden="true"
                  :class="{'ag-hidden': !expanded}"
                  @click="collapse"
            >
                <span class="ag-icon ag-icon-expanded"></span>
            </span>
            <span ref="agClosed" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed" aria-hidden="true"
                  :class="{'ag-hidden': expanded}"
                  @click="expand"
            >
                <span class="ag-icon ag-icon-contracted"></span>
            </span>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            expanded: false
        };
    },
    beforeMount() {
        if (this.params.columnGroup.isExpandable()) {
            this.params.columnGroup.getOriginalColumnGroup().addEventListener('expandedChanged', this.expandedChanged);
        }
    },
    beforeDestroy() {
        if (this.params.columnGroup.isExpandable()) {
            this.params.columnGroup.getOriginalColumnGroup().removeEventListener('expandedChanged', this.expandedChanged);
        }
    },
    methods: {
        expand() {
            this.params.setExpanded(true);
        },
        collapse() {
            this.params.setExpanded(false);
        },
        expandedChanged() {
            this.expanded = this.params.columnGroup.isExpanded();
        }
    }
};
</script>